const UserTagIcon = ({ color = "currentColor" }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.33301 4.66667C5.33301 5.37391 5.61396 6.05219 6.11406 6.55229C6.61415 7.05238 7.29243 7.33333 7.99967 7.33333C8.70692 7.33333 9.3852 7.05238 9.88529 6.55229C10.3854 6.05219 10.6663 5.37391 10.6663 4.66667C10.6663 3.95942 10.3854 3.28115 9.88529 2.78105C9.3852 2.28095 8.70692 2 7.99967 2C7.29243 2 6.61415 2.28095 6.11406 2.78105C5.61396 3.28115 5.33301 3.95942 5.33301 4.66667Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 14V12.6667C4 11.9594 4.28095 11.2811 4.78105 10.781C5.28115 10.281 5.95942 10 6.66667 10H9"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.28 10.4062C12.41 10.2762 12.5644 10.173 12.7342 10.1027C12.9041 10.0323 13.0861 9.99609 13.27 9.99609C13.4539 9.99609 13.6359 10.0323 13.8058 10.1027C13.9756 10.173 14.13 10.2762 14.26 10.4062C14.39 10.5362 14.4931 10.6905 14.5635 10.8604C14.6339 11.0302 14.6701 11.2123 14.6701 11.3962C14.6701 11.58 14.6339 11.7621 14.5635 11.9319C14.4931 12.1018 14.39 12.2562 14.26 12.3862L12 14.6662H10V12.6662L12.28 10.4062Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UserTagIcon;
